import { render, staticRenderFns } from "./app-modal.vue?vue&type=template&id=38b7a2b8&"
import script from "./app-modal.vue?vue&type=script&lang=js&"
export * from "./app-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports